module.exports = __webpack_public_path__ + "img/card-brand-unionpay.4ee3b63b.png";